module.exports = "https://static.zego.com/_next/static/images/Paper-893cf3fd611658d405829b6a14ec79f2.svg";